import Modal from "../shared/Modal";
import "./ModalApplicationNotConnected.css";
import { Button } from "../../ds2/components";

type ModalApplicationNotConnectedProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  appName: string;
};

const ModalApplicationNotConnected = ({
  isOpen,
  onClose,
  onContinue,
  appName,
}: ModalApplicationNotConnectedProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-collection-application-not-connected">
          <div className="modal-collection-application-not-connected-title">
            Please Connect Your {appName} Account
          </div>

          <div className="modal-collection-application-not-connected-content">
            This feature requires that you connect your {appName} account. 
          </div>

          <div className="modal-collection-application-not-connected-footer">
            <div className="modal-collection-application-not-connected-buttons">
              <Button
                variant="secondary"
                onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={() => onContinue()}
              >
                Continue
              </Button>
              
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalApplicationNotConnected;
